<template>
    <div class="col-md-12">
        <div class="row">
            <div class="col-lg-6 col-sm-6 col-xs-12">
                <div class="form-control">
                    <label for="country" class="form-label">Country</label>
                    <v-select :options="countries" title="Countries" label="title"
                              id="country"
                              placeholder="Select Country"
                              :reduce="country => country.code"
                              v-if="countries"
                              autocomplete="shipping country"
                              autocorrect="off"
                              name="country"
                              :clearable="false"
                              required
                              v-validate:country="'required|max:60'"
                              data-vv-as="Country"
                              @input="updateCountry"
                              :value="country"
                              aria-label="Select country"
                              :aria-label="countryAriaLabel"
                    >
                        <template #search="{ attributes, events }">
                            <input
                                class="vs__search"
                                v-bind="attributes"
                                v-on="events"
                                aria-labelledby="country"
                            ></input>
                        </template>
                    </v-select>
                    <span class="validation-errors" v-for="error in errors.collect('country')">{{ error }}</span>
                </div>
            </div>
            <div class="col-lg-6 col-sm-6 col-xs-12">
                <div class="form-control">
                    <label for="state" class="form-label">State</label>
                    <v-select :options="states" title="States" label="title"
                              placeholder="States"
                              id="state"
                              :reduce="state => state.code"
                              :disabled="!hasStates"
                              autocomplete="shipping address-level1"
                              autocorrect="off"
                              v-if="states"
                              name="state"
                              :reset-on-options-change="true"
                              :clearable="false"
                              v-validate:state="hasStates ? 'required' : ''"
                              data-vv-as="State"
                              @input="updateState"
                              :value="state"
                              :aria-label="stateAriaLabel"
                    >
                        <template #search="{ attributes, events }">
                            <input
                                class="vs__search"
                                v-bind="attributes"
                                v-on="events"
                                aria-labelledby="state"
                            ></input>
                        </template>
                    </v-select>
                    <span class="validation-errors" v-for="error in errors.collect('state')">{{ error }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "countryState",
        props: {
            country: {
                type: String,
                required: true,
                default: 'US',
            },
            state: {
                type: String,
                requires: true,
                default: null
            }
        },
        computed: {
            hasCountries: function () {
                return this.countries && this.countries.length > 0;
            },
            hasStates: function () {
                return this.states && this.states.length > 0;
            },
            stateAriaLabel() {
                const { states, state: selectedState } = this;
                if (selectedState && states.length) {
                    const stateObj = states.filter(e => e.code === selectedState)[0];

                    if (stateObj && stateObj.title) {
                        return 'Search for states. Selected state: ' + stateObj.title;
                    }
                }

                return 'Search for states.';
            },
            countryAriaLabel() {
                const { countries, country: selectedCountry } = this;
                if (selectedCountry && countries.length) {
                    const stateObj = countries.filter(e => e.code === selectedCountry)[0];

                    if (stateObj && stateObj.title) {
                        return 'Search for countries. Selected country: ' + stateObj.title;
                    }
                }

                return 'Search for countries.';
            }
        },
        data: () => ({
            countries: null,
            states: null,
            selectedCountry: '',
        }),
        created: function () {
            this.loadCountries();
        },
        watch: {
            country: function () {
                this.updateState(null);
                this.loadStates();
            }
        },
        methods: {
            loadCountries: function () {
                axios.get('/api/v1/countries/list')
                    .then(response => {
                        this.countries = response.data.data;
                        this.loadStates();
                    }).catch(error => console.error(error));
            },
            loadStates: function () {
                if (!this.country) {
                    this.states = [];
                    this.updateState(null);
                    return;
                }
                axios.post('/api/v1/countries/states', {
                    country: this.country,
                }).then(response => {
                    this.states = response.data.data;
                }).catch(error => console.error(error))
            },
            updateCountry: function (country) {
                this.$emit('update:country', country);
                this.states = [];
            },
            updateState: function (state) {
                this.$emit('update:state', state);
            }
        }
    }
</script>
